import { DocUploadedUser } from '@/pages/Registration/Registration.interfaces';
import { Button, Modal } from 'antd';
import React, { FC } from 'react';

type Props = {
  isOpen: boolean;
  activeDocument: DocUploadedUser | null;
  isLoadingDelete: boolean;
  onClose: () => void;
  name: string;
  onSubmit: (fileId: string) => void;
};

export const ModalDelete: FC<Props> = ({
  activeDocument,
  isOpen,
  onClose,
  name,
  onSubmit,
  isLoadingDelete,
}) => {
  return (
    <Modal
      title="Удаление документа"
      footer={[
        <Button key="back" onClick={onClose} htmlType="button">
          Отмена
        </Button>,

        <Button
          key="submit"
          onKeyDown={(e) => (e.key === 'Enter' ? e.preventDefault() : '')}
          color="danger"
          variant="filled"
          htmlType="button"
          loading={isLoadingDelete}
          onClick={() => onSubmit(activeDocument?.fileId as string)}
        >
          Удалить
        </Button>,
      ]}
      onCancel={onClose}
      open={isOpen}
    >
      Вы действительно хотите удалить документ: <b>{name}</b>?
    </Modal>
  );
};
